import { render, staticRenderFns } from "./psp-request-setting.vue?vue&type=template&id=4ffba587&"
import script from "./psp-request-setting.vue?vue&type=script&lang=js&"
export * from "./psp-request-setting.vue?vue&type=script&lang=js&"
import style0 from "./psp-request-setting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports